import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { queryVariantUpdateBlock } from '@theme/utilities';

/**
 * Displays selected-variant specification data and updates on variant change.
 *
 * @extends {Component}
 */
class ProductVariantMetafield extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMetafield);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMetafield);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateMetafield = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newMetafield = queryVariantUpdateBlock(
      event.detail.data.html,
      'product-variant-metafield',
      this.dataset.blockId,
      this.dataset.productId
    );

    if (!newMetafield) return;

    this.className = newMetafield.className;
    this.style.cssText = newMetafield.style.cssText;
    morph(this, newMetafield, { childrenOnly: true });
  };
}

if (!customElements.get('product-variant-metafield')) {
  customElements.define('product-variant-metafield', ProductVariantMetafield);
}
